export const support = {
  blockchain: [
    {
      title: 'FISCO BCOS Underlying Platform',
      text: 'FISCO FISCO BCOS, the financial blockchain underlying open source platform, is created by the Golden Chain Alliance Open Source Working Group led by WeBank. FISCO BCOS was open-sourced in 2017, characterized by strong performance (more than 20,000 single chain TPS, realized new type of extensible rPBFT consensus algorithm), secure and controllable (complete national secret algorithm, support group ring signature and homomorphic encryption, supervision-friendly), easy to use (multi-language SDK, safe and high-speed smart contracts) and other technology advantages, currently has been developed into the largest and most active open source alliance ecosystem in China. ',
      downLabel: 'Source code Downloading',
      wordLabel: 'Learning Documents',
      downLink: 'https://github.com/FISCO-BCOS/FISCO-BCOS',
      wordLink: 'https://fisco-bcos-documentation.readthedocs.io/zh_CN/latest/docs/community.html'
    },
    {
      title: 'WeBASE Middleware platform',
      text: 'WeBASE is the middleware platform between the blockchain application and underlying nodes to create abundant function components and utilities facing multiple objects and based on different scenarios as a way to provide friendly and visualized operable environment. WeBASE can simplify blockchain application development process, reduce the development threshold so as to help developers quickly build blockchain application. ',
      downLabel: 'Source code Downloading',
      wordLabel: 'Learning Documents',
      downLink: 'https://github.com/WeBankFinTech/WeBASE',
      wordLink: 'https://webasedoc.readthedocs.io/zh_CN/latest/'
    },
    {
      title: 'WeIdentity Distributed Identity Management ',
      text: 'WeIdentity, a set of solutions based on Distributed Identity Management of blockchain, is committed to the pan-industry, cross-organizational and cross-regional identity authentication and data cooperation. WeIdentity provides a series of base layer and application interface including distributed entity identification and management, trusted data exchange protocol, etc. to realize the safety authorization and exchange of entity object data (people or objects). ',
      downLabel: 'Source code Downloading',
      wordLabel: 'Learning Documents',
      downLink: 'https://github.com/WeBankFinTech/WeIdentity',
      wordLink: 'https://weidentity.rtfd.io/'
    },
    {
      title: 'WeEvent Messaging Collaboration',
      text: 'WeEvent is committed to improving cooperation efficiency between institutions, reducing costs, connecting different platforms including application, Internet of Things, cloud service and private service to realize interagency and cross-platform event notification and handling without changing the development language and access protocol pf existing commercial system. As a set of distributed event-driven architecture, WeEvent has already established the trusted, reliable and high-efficient event notification mechanism with interagency and cross-platform.',
      downLabel: 'Source code Downloading',
      wordLabel: 'Learning Documents',
      downLink: 'https://github.com/WeBankFinTech/WeEvent',
      wordLink: 'https://weeventdoc.readthedocs.io/zh_CN/latest'
    },
    {
      title: 'WeCross General Cross-Chain ',
      text: 'WeCross stays committed to cross-blockchain trust transfer and business cooperation with cross-industry, interagency and cross-regions to further explore the effective solutions for the failure of interconnection between heterogeneous blockchains due to multidimensional heterogeneity including underlying architecture, data structure, access protocol, safety mechanism, etc. rather than limiting to meet the needs of trusted data exchange after parallel extension of isomorphic blockchain. ',
      downLabel: 'Source code Downloading',
      wordLabel: 'Learning Documents',
      downLink: 'https://github.com/WeBankFinTech/WeCross',
      wordLink: 'https://wecross.readthedocs.io/zh_CN/latest/'
    }
  ],
  developcourse: {
    list: [
      {
        imgUrl: require('@/assets/img/support/art_1.png'),
        title: 'Primer: Blockchain Practical Skills Tree ',
        text: 'What of knowledge is needed for blockchain development? How to start? How to find solutions? Here is a quick guide for newcomer to know blockchain.',
        link: 'https://mp.weixin.qq.com/s/YC5TaCbhjQVmNqI3azYd_Q'
      },
      {
        imgUrl: require('@/assets/img/support/webase1.png'),
        title: 'Blockchain middleware platform WeBASE Architecture/Function Overview ',
        text: 'Understand the overall architecture and application development process of WeBASE',
        link: 'https://mp.weixin.qq.com/s/gTM9qrXfdFWRKzvv3WYlhg'
      },
      {
        imgUrl: require('@/assets/img/support/art_2.png'),
        title: 'FISCO BCOS Introduction, Five-steps to Build Application ',
        text: 'Share how to develop your first DAPP Application based on FISCO BCOS in a high-purity and ultra-concentrated way. ',
        link: 'https://mp.weixin.qq.com/s?__biz=MzA3MTI5Njg4Mw==&mid=2247485305&idx=1&sn=5a8dc012880aac6f5cd3dacd7db9f1d9&chksm=9f2ef565a8597c73b87fd248c41d1a5b9b0e6a6c6c527baf873498e351e3cb532b77eda9377a&token=1215467457&lang=zh_CN#rd'
      },
      {
        imgUrl: require('@/assets/img/support/webase2.png'),
        title: 'WeBASE Data Export: Quick Implementation of Blockchain big data scenarios',
        text: 'Unveil WeBASE data export component function, features and architecture evolution from the perspective of users’ needs. ',
        link: 'https://mp.weixin.qq.com/s/RQ4HoI2B9iN9MtfBzmsnKg'
      },
      {
        imgUrl: require('@/assets/img/support/art_3.png'),
        title: 'FISCO BCOS Smart Contracts Quick Guide',
        text: 'FISCO BCOS supports two types of smart contracts including Solidity and Precompiled and also provides interactive control tools, enabling developers to have interaction with chain, deploy and dispatch smart contracts. ',
        link: 'https://mp.weixin.qq.com/s/XOVz6S8Z8Jn8NmOfr7UDxA'
      },
      {
        imgUrl: require('@/assets/img/support/webase3.png'),
        title: 'WeBASE Function Analysis of Node Pre-component',
        text: 'How to develop a blockchain visualized interface quickly to interact with blockchain, WeBASE-Front is a case in point to meet the expected component.',
        link: 'https://mp.weixin.qq.com/s/3V-Vife4_ne0uDvJ6rtcPg'
      },
      {
        imgUrl: require('@/assets/img/support/art_4.png'),
        title: 'Source Code: Four Perspectives for Blockchain Source Code ',
        text: 'Due to extensive knowledge of blockchain, Core technology of blockchain can be acquired by virtue of understanding the details of source code deeply. ',
        link: 'https://mp.weixin.qq.com/s/Erm1XV9n9gmwVn6-8Tda7w'
      },
      {
        imgUrl: require('@/assets/img/support/webase4.png'),
        title: 'Discussion on Transaction of WeBASE ',
        text: 'Transaction can be regarded as a request data sending to blockchain system for deploy and call contract interface so as to reach the goal of maintaining the life cycle of contracts, asset management and value exchange. ',
        link: 'https://mp.weixin.qq.com/s/2nMaMFP-3h-XIrWNq5Sjvg'
      }
    ],
    referLabel: '进技术群咨询',
    referLink: '',
    moreLabel: 'For more development programming',
    moreLink: 'https://mp.weixin.qq.com/s/1RGKEdcGhZbjqKv7LBrAVA'
  },
  training: [
    [
      {
        imgUrl: require('@/assets/img/support/video_1.png'),
        contentText: 'FISCO BCOS Hands-on',
        video: 'https://v.qq.com/x/page/d0911r5gjg5.html'
      },
      {
        imgUrl: require('@/assets/img/support/video_2.png'),
        contentText: 'FISCO BCOS Smart Contract Crash Course (Volume I) ',
        video: 'https://v.qq.com/x/page/t3130e6wzh2.html'
      },
      {
        imgUrl: require('@/assets/img/support/video_3.png'),
        contentText: 'FISCO BCOS Smart Contract Crash Course (Volume II)',
        video: 'https://v.qq.com/x/page/h3130tubdoz.html'
      }
    ],
    [
      {
        imgUrl: require('@/assets/img/support/video_4.png'),
        contentText: 'Blockchain WeCross Crash Course ',
        video: 'https://v.qq.com/x/page/b31305cge3g.html'
      },
      {
        imgUrl: require('@/assets/img/support/video_5.png'),
        contentText: 'WeCross: interconnection of Cross-chain',
        video: 'https://v.qq.com/x/page/d31309c84w0.html'
      },
      {
        imgUrl: require('@/assets/img/support/video_6.png'),
        contentText: 'Implementation Challenge and realization of Five Application Scenarios of Blockchain ',
        video: 'https://v.qq.com/x/page/k3130acgwwz.html'
      }
    ],
    [
      {
        imgUrl: require('@/assets/img/support/video_7.png'),
        contentText: 'Blockchain Industry Application – Analyze the application practice of blockchain in four scenarios',
        video: 'https://v.qq.com/x/page/w31301nfa7r.html'
      },
      {
        imgUrl: require('@/assets/img/support/video_8.png'),
        contentText: 'Design and Implementation of Blockchain-based Trusted Deposit',
        video: 'http://mooc.people.com.cn/moocpc/classroom/detail.html?id=2216'
      },
      {
        imgUrl: require('@/assets/img/support/video_9.png'),
        contentText: 'Integration between Blockchain and AI Technology',
        video: 'https://v.qq.com/x/page/s3130luhyy4.html'
      }
    ],
    [
      {
        imgUrl: require('@/assets/img/support/video_10.png'),
        contentText: 'Blockchain + Privacy Protection, where to go? ',
        video: 'https://v.qq.com/x/page/t3130is2tkv.html'
      },
      {
        imgUrl: require('@/assets/img/support/video_11.png'),
        contentText: 'Opportunity and Technology Challenge of Alliance Chain ',
        video: 'http://mooc.people.com.cn/moocpc/classroom/detail.html?id=2178'
      }
    ]
  ]
}
